import { headlineTextTemplate, twoColumnsTextOnly } from "./textTemplates";

export const sectionTemplates = [
  headlineTextTemplate,
  twoColumnsTextOnly,
];

export const sectionCategories = [
  "all",
  "text",
  "image",
  "video",
  "audio",
  "table",
  "charts",
  "interactive",
];
